export default "__VITE_ASSET__Bus8Fctk__"